import React, {useState} from 'react';
import {IonIcon, useIonAlert} from '@ionic/react';
import { locationOutline, briefcaseOutline } from 'ionicons/icons';
import useStore from "../zustand/useStore";
import {
    actionToApplyForMatrimonialProfilePost, actionToDeleteMatrimonialPostData,
} from "../apiHelpers/CommonAction";
import AddMatrimonialCandidateProfileModal from "./AddMatrimonialCandidateProfileModal";

export default function MatrimonyProfileCard({ profile,handleProfileItemClick,selectedId }) {
    const {userAuthDetail,userMatrimonialProfileData} = useStore();
    const matrimonialProfileData = userMatrimonialProfileData?.matrimonialProfileData?.[0]
    const {userInfo} = userAuthDetail;
    const [presentAlert] = useIonAlert();
    const [matrimonialProfileAddModal,setMatrimonialProfileAddModal] = useState(false);
    const [dataForEditing,setDataForEditing] = useState(null);
    const [isLoading,setIsLoading] = useState(false);

    const openMatrimonialInterestMail = async (data) => {
        let interestedMembers = [];
        if (data?.interested_member_id_array) {
            interestedMembers = JSON.parse(data.interested_member_id_array);
        }

        if (!interestedMembers?.includes(userInfo?.id)) {
            interestedMembers.push(userInfo?.id);
            let template = await actionToApplyForMatrimonialProfilePost(
                data?.id,
                JSON.stringify(interestedMembers)
            );

            const subject = encodeURIComponent("Matrimonial Interest - Suitable Match");
            let body = encodeURIComponent(
                `Hello,\n\nI am interested in this matrimonial profile.\n\nThanks,\n${userInfo?.name || ''}`
            );

            if (template) {
                let filledTemplate = template
                    .replace(/{PROFILE_URL}/g, matrimonialProfileData?.pdf_url || "")
                    .replace(/{NAME}/g, matrimonialProfileData?.name || "")
                    .replace(/{MOBILE}/g, matrimonialProfileData?.phone || "")
                    .replace(/{EMAIL}/g, matrimonialProfileData?.email || "");

                body = encodeURIComponent(filledTemplate);
            }

            window.location.href = `mailto:${data?.email}?subject=${subject}&body=${body}`;
        }
    };


    const contactMatrimonialProfile = (data)=>{
        if(matrimonialProfileData?.id) {
            presentAlert({
                header: 'Are you sure?',
                cssClass: 'custom_site_alert_toast',
                message: 'You want to show interest this profile.',
                buttons: [
                    {text: 'Cancel', role: 'cancel'},
                    {text: 'Apply', role: 'confirm', handler: () => openMatrimonialInterestMail(data)},
                ],
            });
        }
    }

    const callFunctionToDeletePost = (id,userId)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete your profile.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteMatrimonialPostData(id,userId)
                    }},
            ],
        });
    }

    const callFunctionToSetEditData = (data)=>{
        setDataForEditing(data);
        setMatrimonialProfileAddModal(true);
    }

    return (
        <div className={`matrimony-card ${selectedId === profile?.id ? 'active' : ''}`}>
            <div className="matrimony-card-img-cont">
                <img
                    onClick={()=>handleProfileItemClick(profile)}
                    src={
                        (Array.isArray(profile.image_url)
                                ? profile.image_url
                                : JSON.parse(profile.image_url || "[]")
                        )[0]
                    }
                    alt={profile.name}
                    className="matrimony-card-img"
                />
            </div>
            <div className="matrimony-card-info">
                <h3 className="matrimony-card-name"  onClick={()=>handleProfileItemClick(profile)}>{profile.name}</h3>
                <p className="matrimony-card-details" onClick={()=>handleProfileItemClick(profile)}>
                    {profile.age} yrs | {profile.height} | {profile.religion}, {profile.caste}
                </p>
                <p className="matrimony-card-occupation" onClick={()=>handleProfileItemClick(profile)}>
                    <IonIcon icon={briefcaseOutline} /> {profile.occupation}
                </p>
                <p className="matrimony-card-location"  onClick={()=>handleProfileItemClick(profile)}>
                    <IonIcon icon={locationOutline} /> {profile.location}
                </p>
                <div className={`approved_tag_section_tag ${profile?.is_approved ? 'approved' : 'not_approved'}`}>
                    {profile?.is_approved ? 'Approved' : 'Pending'}
                </div>
                <div className={"in_card_action_buttons_container"}>
                    {(selectedId !== profile?.id) ?
                        <div onClick={()=>handleProfileItemClick(profile)} className="in_card_action_button_edit_del open">
                            Open
                        </div>:''
                    }
                    {(userInfo?.id === profile?.created_by) ?
                        <>
                            <div onClick={()=>callFunctionToSetEditData(profile)} className="in_card_action_button_edit_del edit">
                                Edit
                            </div>
                            <div onClick={()=>callFunctionToDeletePost(profile?.id,profile?.created_by)} className="in_card_action_button_edit_del">
                                Delete
                            </div>
                        </>
                        :
                        <>
                            {(profile?.applied_member_id_array && JSON.parse(profile?.applied_member_id_array).includes(userInfo?.id)) ?
                                <div className="in_card_action_button_edit_del">
                                    Contacted
                                </div>
                                :
                                <div onClick={() => contactMatrimonialProfile(profile)} className="in_card_action_button_edit_del">
                                    Contact
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
            {/*/////// JOB CANDIDATE PROFILE //////////////*/}
            {matrimonialProfileAddModal &&
              <AddMatrimonialCandidateProfileModal dataForEditing={dataForEditing} isOpen={matrimonialProfileAddModal} onClose={() => setMatrimonialProfileAddModal(false)} setIsLoading={setIsLoading}/>
            }
            {/*/////// JOB CANDIDATE PROFILE //////////////*/}
        </div>
    );
}
